import { takeEvery } from 'redux-saga/effects';
import { fetchProductsAction, setPageProductsLevelAction } from '../actions';
import { fetchProductsSaga } from './fetchProductsSaga';
import { setPageProductsLevelSaga } from './setPageProductsLevelSaga';

export function* productsRootSaga() {
  yield takeEvery(fetchProductsAction.TYPE, fetchProductsSaga);
  yield takeEvery(setPageProductsLevelAction.TYPE, setPageProductsLevelSaga);
}
